// extracted by mini-css-extract-plugin
export default {"container":"plain_container__3K6vi","inner":"plain_inner__2pNuG","arrow":"plain_arrow__2zoMX"};